import { SeriesConfiguration } from '../../../widgets/models';

export class ScatterPlotSeriesConfiguration extends SeriesConfiguration {
    isXAxis: boolean;

    constructor(guid, color, symbol) {
        super(guid, color, symbol);
    }
}